module.exports = __webpack_public_path__ + "media/images/application/template/alert-widget-bg-ded9b76e98c91682c516947499710215.png";